<template>
  <div class="staffbtn">
    <div>{{staff.name}}</div>
    <button @click="$emit('del')">
      <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5002 0.5C5.59644 0.5 0 6.09644 0 13.0002C0 19.9036 5.59644 25.5 12.5002 25.5C19.4036 25.5 25 19.9036 25 13.0002C24.9918 6.09999 19.4004 0.508162 12.5002 0.5ZM12.5002 23.4841C6.70998 23.4841 2.01629 18.7904 2.01629 13.0002C2.01629 7.20998 6.70998 2.51629 12.5002 2.51629C18.29 2.51629 22.9841 7.20998 22.9841 13.0002C22.9773 18.7875 18.2875 23.4773 12.5002 23.4841ZM16.9912 8.50876C16.5977 8.11522 15.9593 8.11522 15.5658 8.50876L12.5002 11.5744L9.43493 8.50876C9.18014 8.25397 8.80896 8.15461 8.46084 8.24794C8.11273 8.34127 7.84091 8.61308 7.74794 8.96084C7.65461 9.30896 7.75433 9.68014 8.00876 9.93493L11.0744 13.0002L8.00876 16.0654C7.61771 16.4593 7.61877 17.0956 8.0116 17.488C8.40407 17.8809 9.04033 17.8819 9.43422 17.4909L12.5002 14.4256L15.5654 17.4912C15.9597 17.8823 16.5956 17.8812 16.988 17.4884C17.3805 17.0959 17.3819 16.4597 16.9905 16.0658L13.9256 13.0002L16.9912 9.93493C17.1804 9.74579 17.2868 9.48958 17.2868 9.22202C17.2868 8.95446 17.1807 8.6979 16.9912 8.50876Z" fill="#848484"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: ['staff', 'type']

}
</script>

<style lang="scss" scoped>
.staff {
  background-color: #E9F5FC;
}
.pts {
  background-color: #FFE4E4E5;
}
.staffbtn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 11.5px 15px 11.5px 25px;
  border-radius: 25px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.1em;
  color: #848484;
  button {
    background-color: transparent;
  }
}
</style>
